import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { toDisplayAssetUrl } from "@/lib/assets";
import { cn } from "@/lib/utils";

function preventDefault(event: { preventDefault: () => void }) {
  event.preventDefault();
}

function getInitials(name: string | null | undefined) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "TF";

  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export default function ProfileAvatar({
  name,
  imageUrl,
  className,
  fallbackClassName,
  imageClassName,
}: {
  name: string | null | undefined;
  imageUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
  imageClassName?: string;
}) {
  const displayUrl = toDisplayAssetUrl(imageUrl);

  return (
    <Avatar className={className}>
      {displayUrl ? (
        <AvatarImage
          src={displayUrl}
          alt={name || "Profile image"}
          draggable={false}
          onContextMenu={preventDefault}
          onDragStart={preventDefault}
          className={cn("object-cover select-none", imageClassName)}
        />
      ) : null}
      <AvatarFallback className={fallbackClassName}>{getInitials(name)}</AvatarFallback>
    </Avatar>
  );
}
